import React, { useState } from 'react';
import './RegulationModal.css';
import API_BASE_URL from '../../config/api';

const RegulationModal = ({ onAccepted }) => {
  const [acceptedRegulation, setAcceptedRegulation] = useState(false);
  const [acceptedNotifications, setAcceptedNotifications] = useState(false);
  const [acceptedImageCollection, setAcceptedImageCollection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Only the main regulation (with Alínea a) is mandatory for submitting
  const canSubmit = acceptedRegulation;

  const handleAccept = async () => {
    if (!canSubmit) return;

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/user/accept-regulation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acceptedNotifications,
          acceptedImageCollection
        })
      });

      if (response.ok) {
        localStorage.setItem('acceptedRegulation', 'true');
        onAccepted();
      } else {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao aceitar o regulamento');
      }
    } catch (err) {
      console.error('Error accepting regulation:', err);
      setError(err.message || 'Ocorreu um erro. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="regulation-modal-overlay">
      <div className="regulation-modal">
        <div className="regulation-modal-header">
          <h2>Regulamento Interno & Consentimentos</h2>
        </div>
        <div className="regulation-modal-body">
          <p>Bem-vindo ao Clube Desportivo da Póvoa!</p>
          <p>Para continuar a utilizar a nossa plataforma, é necessário ler e aceitar o nosso regulamento interno, política de privacidade e dar os consentimentos necessários.</p>

          <div className="regulation-content-placeholder">
            <h3>Termos Principais</h3>
            <ul>
              <li>O utilizador compromete-se a fornecer dados verdadeiros.</li>
              <li>O acesso à área reservada é pessoal e intransmissível.</li>
              <li>O clube reserva-se ao direito de suspender contas que violem os termos.</li>
              <li>Os dados são tratados de acordo com o RGPD.</li>
            </ul>
            <div className="regulation-download-highlight">
              <p>Consulte o documento completo para melhor compreensão:</p>
              <a href={`${API_BASE_URL}/docs/regulamento_cdpovoa.pdf`} target="_blank" rel="noopener noreferrer" className="btn-download-pdf">
                <i className="fa-solid fa-file-pdf"></i> Visualizar Regulamento Interno (PDF)
              </a>
            </div>
          </div>

          <div className="rgpd-container">
            <h3>2. Regulamento Geral de Proteção de Dados - RGPD</h3>
            <p className="rgpd-intro">
              Em cumprimento com o Regulamento Geral de Proteção de Dados, prevemos as seguintes alíneas para autorização:
            </p>
            <div className="rgpd-items">
              <div className="rgpd-item">
                <span className="rgpd-letter">a)</span>
                <p className="rgpd-text">
                  a utilização dos dados pessoais do encarregado de educação e atleta por parte do Clube Desportivo da Póvoa para gestão interna, não sendo utilizados por terceiros;
                </p>
              </div>
              <div className="rgpd-item">
                <span className="rgpd-letter">b)</span>
                <p className="rgpd-text">
                  a utilização dos dados pessoais de encarregado de educação e atleta por parte do Clube Desportivo da Póvoa para envio de comunicação da modalidade, como agendamento de treinos, datas de torneios, jogos, eventos, newsletter e outros assuntos de interesse ao funcionamento regular da modalidade;
                </p>
              </div>
              <div className="rgpd-item">
                <span className="rgpd-letter">c)</span>
                <p className="rgpd-text">
                  a utilização de fotografias e vídeo do atleta para promoção da modalidade nos meios de divulgação do clube.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="regulation-modal-footer">
          {error && <div className="error-message">{error}</div>}

          <div className="regulation-modal-consents">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={acceptedRegulation}
                onChange={(e) => setAcceptedRegulation(e.target.checked)}
                disabled={loading}
              />
              <span className={`custom-checkbox ${acceptedRegulation ? 'checked' : ''}`}>
                {acceptedRegulation && <i className="fa-solid fa-check"></i>}
              </span>
              <span className="checkbox-text">
                Li e aceito o <strong>Regulamento Interno</strong> do clube e autorizo a utilização dos dados pessoais para <strong>gestão interna</strong> (conforme a <strong>Alínea a</strong> do RGPD). <span className="required-badge">* Obrigatório</span>
              </span>
            </label>

            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={acceptedNotifications}
                onChange={(e) => setAcceptedNotifications(e.target.checked)}
                disabled={loading}
              />
              <span className={`custom-checkbox ${acceptedNotifications ? 'checked' : ''}`}>
                {acceptedNotifications && <i className="fa-solid fa-check"></i>}
              </span>
              <span className="checkbox-text">
                Autorizo o envio de <strong>comunicações da modalidade</strong> como treinos, torneios, jogos e newsletter (conforme a <strong>Alínea b</strong> do RGPD). <span className="optional-badge">(Opcional)</span>
              </span>
            </label>

            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={acceptedImageCollection}
                onChange={(e) => setAcceptedImageCollection(e.target.checked)}
                disabled={loading}
              />
              <span className={`custom-checkbox ${acceptedImageCollection ? 'checked' : ''}`}>
                {acceptedImageCollection && <i className="fa-solid fa-check"></i>}
              </span>
              <span className="checkbox-text">
                Autorizo a recolha e tratamento de <strong>fotografias e vídeo</strong> do atleta para promoção da modalidade (conforme a <strong>Alínea c</strong> do RGPD). <span className="optional-badge">(Opcional)</span>
              </span>
            </label>
          </div>

          <button
            className="btn-accept-regulation"
            onClick={handleAccept}
            disabled={!canSubmit || loading}
          >
            {loading ? 'A processar...' : 'Aceitar e Continuar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegulationModal;
